"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentAssessmentRecordSchema = exports.ExperimentAssessmentReportSchema = exports.ExperimentAssessmentRaisedSchema = exports.ExperimentAssessModeSchema = exports.ExperimentAssessMode = void 0;
const z = require("zod");
const experiment_error_profile_types_1 = require("../../../PackageDataAdjudication/experiment-error-profile.types");
const package_data_adjudication_types_1 = require("../../../PackageDataAdjudication/package-data-adjudication.types");
var ExperimentAssessMode;
(function (ExperimentAssessMode) {
    ExperimentAssessMode["Dispatched"] = "dispatched";
    ExperimentAssessMode["Refreshed"] = "refreshed";
})(ExperimentAssessMode || (exports.ExperimentAssessMode = ExperimentAssessMode = {}));
exports.ExperimentAssessModeSchema = z.nativeEnum(ExperimentAssessMode);
exports.ExperimentAssessmentRaisedSchema = z.object({
    newRequests: z.number().int(),
    joinedRequests: z.number().int(),
    wouldRaiseDisagreements: z.number().int(),
});
exports.ExperimentAssessmentReportSchema = z.object({
    experimentId: z.string(),
    mode: exports.ExperimentAssessModeSchema,
    assessmentStatus: package_data_adjudication_types_1.ExperimentAssessmentStatusSchema,
    profile: experiment_error_profile_types_1.ExperimentErrorProfileSchema,
    raised: exports.ExperimentAssessmentRaisedSchema,
    assessedAt: z.date(),
});
exports.ExperimentAssessmentRecordSchema = z.object({
    experimentId: z.string(),
    assessmentStatus: package_data_adjudication_types_1.ExperimentAssessmentStatusSchema,
    errorProfile: experiment_error_profile_types_1.ExperimentErrorProfileSchema.nullable(),
    assessedAt: z.date().nullable(),
    dispatchedAt: z.date().nullable(),
});
//# sourceMappingURL=experiment-assessment.js.map